
import { authStore } from '@/store/typed';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Auth extends Vue {
  get codeVerifier() {
    return authStore.codeVerifier;
  }

  render() {
    return null;
  }

  async created() {
    const code = this.$route.query.code;

    if (this.$route.query.action === 'restart') {
      this.$router.replace({ name: 'oauth_start' });
      return;
    }

    if(!code) {
      this.redirectToForbidden();
    }

    authStore.setAuthorizationCode(code as string);

    try {
      await authStore.requestToken();

      await this.$nextTick();

      this.$router.push({ name: 'index'}).catch(() => {});
    } catch(error) {
      console.error(error);
      this.redirectToForbidden();
    }
  }

  redirectToForbidden() {
    this.$router.push({ name: 'forbidden' });
  }
}
